"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ordering = exports.createAutoDefinition = exports.NewType = exports.AutoType = exports.Union = exports.Runnable = exports.Traversable = exports.Thenable = exports.Tap = exports.Swap = exports.Show = exports.Semigroup = exports.Ord = exports.Natural = exports.Monoid = exports.Monad = exports.Functor = exports.Foldable = exports.Filterable = exports.Eq = exports.Enum = exports.EnumType = exports.BoxedEnumType = exports.BoxedEnum = exports.Applicative = void 0;
var applicative_1 = require("./applicative");
Object.defineProperty(exports, "Applicative", { enumerable: true, get: function () { return __importDefault(applicative_1).default; } });
var boxedEnum_1 = require("./boxedEnum");
Object.defineProperty(exports, "BoxedEnum", { enumerable: true, get: function () { return __importDefault(boxedEnum_1).default; } });
var boxedEnumType_1 = require("./boxedEnumType");
Object.defineProperty(exports, "BoxedEnumType", { enumerable: true, get: function () { return __importDefault(boxedEnumType_1).default; } });
var enumType_1 = require("./enumType");
Object.defineProperty(exports, "EnumType", { enumerable: true, get: function () { return __importDefault(enumType_1).default; } });
var enum_1 = require("./enum");
Object.defineProperty(exports, "Enum", { enumerable: true, get: function () { return __importDefault(enum_1).default; } });
var eq_1 = require("./eq");
Object.defineProperty(exports, "Eq", { enumerable: true, get: function () { return __importDefault(eq_1).default; } });
var filterable_1 = require("./filterable");
Object.defineProperty(exports, "Filterable", { enumerable: true, get: function () { return __importDefault(filterable_1).default; } });
var foldable_1 = require("./foldable");
Object.defineProperty(exports, "Foldable", { enumerable: true, get: function () { return __importDefault(foldable_1).default; } });
var functor_1 = require("./functor");
Object.defineProperty(exports, "Functor", { enumerable: true, get: function () { return __importDefault(functor_1).default; } });
var monad_1 = require("./monad");
Object.defineProperty(exports, "Monad", { enumerable: true, get: function () { return __importDefault(monad_1).default; } });
var monoid_1 = require("./monoid");
Object.defineProperty(exports, "Monoid", { enumerable: true, get: function () { return __importDefault(monoid_1).default; } });
var natural_1 = require("./natural");
Object.defineProperty(exports, "Natural", { enumerable: true, get: function () { return __importDefault(natural_1).default; } });
var ord_1 = require("./ord");
Object.defineProperty(exports, "Ord", { enumerable: true, get: function () { return __importDefault(ord_1).default; } });
var semigroup_1 = require("./semigroup");
Object.defineProperty(exports, "Semigroup", { enumerable: true, get: function () { return __importDefault(semigroup_1).default; } });
var show_1 = require("./show");
Object.defineProperty(exports, "Show", { enumerable: true, get: function () { return __importDefault(show_1).default; } });
var swap_1 = require("./swap");
Object.defineProperty(exports, "Swap", { enumerable: true, get: function () { return __importDefault(swap_1).default; } });
var tap_1 = require("./tap");
Object.defineProperty(exports, "Tap", { enumerable: true, get: function () { return __importDefault(tap_1).default; } });
var thenable_1 = require("./thenable");
Object.defineProperty(exports, "Thenable", { enumerable: true, get: function () { return __importDefault(thenable_1).default; } });
var traversable_1 = require("./traversable");
Object.defineProperty(exports, "Traversable", { enumerable: true, get: function () { return __importDefault(traversable_1).default; } });
var runnable_1 = require("./runnable");
Object.defineProperty(exports, "Runnable", { enumerable: true, get: function () { return __importDefault(runnable_1).default; } });
const union_1 = __importDefault(require("./union"));
/**
 * Creates an union type
 */
const Union = (data) => {
    const { name, cases, extensions = [], config = {}, constructors = {} } = data;
    return (0, union_1.default)(name, cases, extensions, config).constructors(constructors);
};
exports.Union = Union;
__exportStar(require("./functor"), exports);
var union_2 = require("./union");
Object.defineProperty(exports, "AutoType", { enumerable: true, get: function () { return union_2.AutoType; } });
Object.defineProperty(exports, "NewType", { enumerable: true, get: function () { return union_2.NewType; } });
Object.defineProperty(exports, "createAutoDefinition", { enumerable: true, get: function () { return union_2.createAutoDefinition; } });
var ord_2 = require("./ord");
Object.defineProperty(exports, "Ordering", { enumerable: true, get: function () { return ord_2.Ordering; } });
